/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { AddWhite, EditIcon, SearchIcon, TrashIcon } from '../../../assets/icons';
import { Constants, getUpdatedState, Globals } from '../../../utils';
import { Input, Modal, Pagination } from '../../../components';
import { MaintenancePlanService } from '../../../services';
import ModalCreateCategory from "./modal-create-category";

const MaintenancePlan = () => {
  const nav = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data, deleteItem, filters, goToPage, onChange, pagination, reload, search } = useFetchTable();

  return (
    <main className="w-full">
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <ModalCreateCategory
          onClose={() => setIsModalOpen(false)}
          onSuccess={() => reload()}
        />
      </Modal>

      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
        <div className="flex flex-1 flex-wrap items-end gap-3">
          <Input
            className={{ base: 'max-w-60' }}
            placeholder="Buscar categorías"
            value={filters.search}
            onValueChange={v => onChange('search', v)}
            prepend={
              <img src={SearchIcon} className="w-4 h-4" alt="" />
            }
          />

          <div className="flex gap-4">
            <button
              className="bg-red hover:bg-red-700 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
              onClick={search}
            >
              Filtrar
            </button>
            <button
              className="bg-black hover:bg-gray-800 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
              onClick={() => reload()}
            >
              Limpiar
            </button>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between py-4 px-3">
        <p className="text-2xl font-bold text-center">Categorías</p>

        <button onClick={() => setIsModalOpen(true)} className="flex items-center gap-2 bg-green text-white px-4 py-1.5 rounded-lg font-semibold">
          <img src={AddWhite} className="w-4 h-4" alt="" />
          Nueva
        </button>
      </div>

      <div className="grid grid-cols-3 gap-4">
        {data.map((item) => (
          <div key={item.id} className="bg-white border border-gray6 rounded-lg px-3 py-2">
            <p className="text-lg">{ item.name }</p>
            <div className="flex items-center justify-end gap-3">
              <img
                src={EditIcon}
                className="w-5 h-5 object-contain cursor-pointer"
                onClick={() => nav(`/maintenance-plan/${btoa(item.id)}/edit`)}
                alt=""
              />
              <img
                src={TrashIcon}
                className="w-5 h-5 object-contain cursor-pointer"
                onClick={() => deleteItem(item.id)}
                alt=""
              />
            </div>
          </div>
        ))}

        {!data.length && (
          <p className="py-8 text-text text-center col-span-3">Sin datos para mostrar</p>
        )}

        <div className="px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Pagination
            active={pagination.page}
            pages={pagination.pages}
            onChange={goToPage}
          />
        </div>
      </div>
    </main>
  );
};

const useFetchTable = () => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    search: '',
  };

  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };

  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);

  const fetchData = async () => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      const payload = await getUpdatedState(setFilters);
      const response = await MaintenancePlanService.admin.findAll(payload);
      const { data, ...rest } = response;

      setData(data);
      setPagination(rest);
      setCanFetch(true);

    } catch (error) {
      setData([]);
      setCanFetch(true);
    }
  }

  const deleteItem = async (id) => {
    Globals.confirm('¿Estás seguro de que deseas eliminar esta categoría? Esta acción también eliminará todas las subcategorías asociadas y no se puede deshacer', async () => {
      if (!canFetch) return;
      setCanFetch(false);

      try {
        await MaintenancePlanService.admin.destroy(id);
        toast.success('Categoría eliminada con éxito');
        fetchData();

      } catch (error) {
        toast.error(String(error));
      }
      setCanFetch(true);
    });
  }

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters(initialFilters);
    fetchData();
  }

  const goToPage = async (page) => {
    const pagination = await getUpdatedState(setPagination);
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
      fetchData();
    }
  }

  const onChange = (target, value) => {
    setFilters(s => ({ ...s, page: 1, [target]: value }));
  }

  useEffect(() => {
    fetchData();
  }, []);

  return {
    data,
    deleteItem,
    filters,
    goToPage,
    isLoading: !canFetch,
    onChange,
    pagination,
    reload,
    search: fetchData,
  }
}

export default MaintenancePlan;